import {
  EoFormControlConfig,
  IEoFormControlConfig,
} from '../eo-form/eo-form.config';

export interface IEoAutoCompleteConfig<T> extends IEoFormControlConfig {
  type?: 'autocomplete';
  inputIcon?: string;
  inputStyleClass?: string;
  apiUrl?: string;
  optionLabel?: string;
  optionValue?: string;
  suggestions?: T[];
  autocompleteStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  showEmptyMessage?: boolean;
  emptyMessage?: string;
  appendTo?: any;
  minLength?: number;
  maxLength?: number;
  multiple?: boolean;
}

export class EoAutoCompleteConfig<T>
  extends EoFormControlConfig
  implements IEoAutoCompleteConfig<T>
{
  override type?: 'autocomplete';
  inputIcon?: string;
  inputStyleClass?: string;
  apiUrl?: string;
  optionLabel?: string;
  optionValue?: string;
  suggestions?: T[];
  autocompleteStyleClass?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  showEmptyMessage?: boolean;
  emptyMessage?: string;
  appendTo?: any;
  minLength?: number;
  maxLength?: number;
  multiple?: boolean;

  constructor();
  constructor(obj: IEoAutoCompleteConfig<T>);
  constructor(obj?: IEoAutoCompleteConfig<T>) {
    super(obj as IEoFormControlConfig);
    this.type = 'autocomplete';
    this.inputIcon = obj?.inputIcon;
    this.inputStyleClass = obj?.inputStyleClass;
    this.optionLabel = obj?.optionLabel;
    this.optionValue = obj?.optionValue;
    this.suggestions = obj?.suggestions;
    this.autocompleteStyleClass = obj?.autocompleteStyleClass;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.showClear = obj?.showClear;
    this.showEmptyMessage = obj?.showEmptyMessage;
    this.emptyMessage = obj?.emptyMessage;
    this.appendTo = obj?.appendTo;
    this.minLength = obj?.minLength;
    this.maxLength = obj?.maxLength;
    this.multiple = obj?.multiple;
    this.apiUrl = obj?.apiUrl;
  }
}
